const selectors = {
  form: '[data-newsletter-form]',
  messageError: '.newsletter__message--error',
  messageSuccess: '.newsletter__message--success',
};

const classes = {
  success: 'has-success',
  error: 'has-error',
  hidden: 'hidden',
  messageError: 'newsletter__message--error',
};

if (!customElements.get('newsletter-component')) {
  customElements.define(
    'newsletter-component',
    class NewsletterComponent extends HTMLElement {
      constructor() {
        super();

        this.newsletter = this.querySelector(selectors.form);
        this.klaviyoListID = this.dataset.klaviyoListId || null;
        this.email = this.newsletter.querySelector('input[type="email"]');
        this.companyId = window.theme?.api?.klaviyo?.id || null;
        this.sessionStorage = window.sessionStorage;
        this.stopSubmit = true;
        this.formID = null;
        this.klaviyoListForm = !!(this.klaviyoListID?.length && this.companyId?.length);
      }

      connectedCallback() {
        if (window.location.pathname === '/challenge') {
          return;
        }

        this.newsletterSubmit = (e) => this.klaviyoListForm
          ? this.klaviyoListSubmitEvent(e)
          : this.newsletterSubmitEvent(e);

        this.newsletter.addEventListener('submit', this.newsletterSubmit);
        if (!this.klaviyoListForm) this.showMessage();
      }

      klaviyoListSubmitEvent(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (!this.emailValidation()) {
          this.setErrorState(this.newsletter);
          return;
        }

        fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`, this.formData())
          .then((response) => {
            if (response.status === 202) {
              this.setSuccessState(this.newsletter);
              this.form.reset();
            } else {
              this.setErrorState(this.newsletter);
            }
            console.log(response);
          })
      }

      emailValidation() {
        if (this.email) {
          const emailValue = this.email.value;
          const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          const result = re.test(emailValue);

          return result && result !== '';
        } else {
          return true;
        }
      }

      newsletterSubmitEvent(e) {
        if (this.stopSubmit) {
          e.preventDefault();
          e.stopImmediatePropagation();

          this.removeStorage();
          this.writeStorage();
          this.stopSubmit = false;
          this.newsletter.submit();
        }
      }

      writeStorage() {
        if (this.sessionStorage !== undefined) {
          this.sessionStorage.setItem('newsletter_form_id', this.newsletter.id);
        }
      }

      readStorage() {
        this.formID = this.sessionStorage.getItem('newsletter_form_id');
      }

      removeStorage() {
        this.sessionStorage.removeItem('newsletter_form_id');
      }

      showMessage() {
        this.readStorage();

        if (this.newsletter.id === this.formID) {
          const newsletter = document.getElementById(this.formID);
          const submissionSuccess = window.location.search.indexOf('?customer_posted=true') !== -1;
          const submissionFailure = window.location.search.indexOf('accepts_marketing') !== -1;

          if (submissionSuccess) {
            this.setSuccessState(newsletter);
          } else if (submissionFailure) {
            this.setErrorState(newsletter);
          }

          if (submissionSuccess || submissionFailure) {
            window.addEventListener('load', () => {
              this.scrollToForm(newsletter);
            });
          }
        }
      }

      setSuccessState(newsletter, message = false) {
        if (message) newsletter.querySelector(selectors.messageSuccess).innerHTML = message;
        newsletter.classList.remove(classes.error);
        newsletter.classList.add(classes.success);
      }

      setErrorState(newsletter, message) {
        if (message) newsletter.querySelector(selectors.messageError).innerHTML = message;
        newsletter.classList.remove(classes.success);
        newsletter.classList.add(classes.error);
      }

      scrollToForm(newsletter) {
        const rect = newsletter.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.left >= 0 && rect.bottom <= theme.windowHeight && rect.right <= theme.windowWidth;

        if (!isVisible) {
          setTimeout(() => {
            window.theme.scrollTo(newsletter.getBoundingClientRect().top);
          }, 500);
        }
      }

      formData() {
        return {
          method: 'POST',
          headers: {
            revision: '2026-01-15',
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Newsletter form',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: this.email?.value ? this.email?.value : '',
                      properties: {
                        marketingOptIn: true,
                      },
                    },
                  },
                },
              },
              relationships: {list: {data: {type: 'list', id: this.klaviyoListID}}},
            },
          }),
        };
      }
    }
  );
}
